/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
// import RGL, { WidthProvider } from "react-grid-layout";
import Filters from "./Filters";
import Table from "./Table";
import Graph from "./Graph";
import Input from "../../Builder/nodes/Logic/Inputs/Input";
import StyledTabContainer from "../../Common/StyledTabContainer";
import FullScreenLoadingIndicator from "../../Common/FullScreenLoadingIndicator";

// const ReactGridLayout = WidthProvider(RGL);

// colours for each comms/status type
const colours = {
  sms: "#880",
  voice: "#088",
  email: "#808",
  delivered: "#46be8a",
  sent: "#926dde",
  failed: "#62a8ea",
  expired: "#f96868",
  pending: "#f96868",
  cancelled: "#f96868",
  unknown: "#f96868",
};

// labels for each comms/status type
const labels = {
  sms: (
    <span title="SMS">
      <i className="fa fa-comment" /> SMS
    </span>
  ),
  email: (
    <span title="e-mail">
      <i className="fa fa-envelope" /> Email
    </span>
  ),
  voice: (
    <span title="Voice">
      <i className="fa fa-microphone" /> Voice
    </span>
  ),
  delivered: (
    <span title="Delivered">
      <i className="fa fa-check" /> Delivered
    </span>
  ),
  sent: (
    <span title="Sent">
      <i className="fa fa-share" /> Sent
    </span>
  ),
  expired: (
    <span title="Expired">
      <i className="fa fa-clock-o" /> Expired
    </span>
  ),
  pending: (
    <span title="Pending">
      <i className="fa fa-clock-o" /> Pending
    </span>
  ),
  cancelled: (
    <span title="Cancelled">
      <i className="fa fa-clock-o" /> Cancelled
    </span>
  ),
  unknown: (
    <span title="Unknown">
      <i className="fa fa-clock-o" /> Unknown
    </span>
  ),
  failed: (
    <span title="Failed">
      <i className="fa fa-times" /> Failed
    </span>
  ),
};

function Report({
  projectUUID,
  broadcastUUID,
  inboundUUID,
  eventUUID,
  startDate,
  endDate,
  comms,
  messageStatus,
  hideFilters,
}) {
  const [reportTab, setReportTab] = useState(
    hideFilters ? "table" : localStorage.getItem("reportTab") || "graph"
  );
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(null);

  const [loading, setLoading] = useState({ graph: false, table: false });
  const [needsRefresh, setNeedsRefresh] = useState(false);

  // UTC warning
  const tzOffset = new Date().getTimezoneOffset();
  const [hideUTCWarning, setHideUTCWarning] = useState(
    localStorage.getItem("hideUTCWarning")
  );

  const location = useLocation();
  useEffect(() => {
    // Scroll to the element with the ID from the fragment identifier
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <FullScreenLoadingIndicator loading={loading.graph || loading.table} />
      <Filters
        hideFilters={hideFilters}
        projectUUID={projectUUID}
        broadcastUUID={broadcastUUID}
        inboundUUID={inboundUUID}
        eventUUID={eventUUID}
        startDate={startDate}
        endDate={endDate}
        comms={comms}
        messageStatus={messageStatus}
        loading={loading}
        colours={colours}
        labels={labels}
        submitFilters={(filt) => {
          setFilters({
            ...filt,
            accounts: filt.accounts.map((acc) => acc.value),
            customers: filt.customers.map((cus) => cus.value),
          });
          setNeedsRefresh(true);
        }}
      />

      <div className="text-center red-800">{error}</div>
      <div id="report" className="bg-white p-3 rounded-3">
        {!hideFilters && (
          <Input
            value={[reportTab]}
            onChange={([v]) => {
              setReportTab(v);
              localStorage.setItem("reportTab", v);
            }}
            options={[
              { value: "graph", label: "Graph" },
              { value: "table", label: "Table" },
            ]}
            inputType="radio"
          />
        )}

        <Tab.Container
          activeKey={reportTab}
          id="controlled-report-type-tab"
          animation={false}
          mountOnEnter
          unmountOnExit
        >
          <StyledTabContainer
            className="mb-3"
            isBackgroundFixed
            id="report-type-tabs"
          >
            <Tab.Content>
              <Tab.Pane eventKey="graph">
                <div style={{ height: "500px" }}>
                  <Graph
                    filters={filters}
                    loading={loading.graph}
                    setLoading={(v) => setLoading((p) => ({ ...p, graph: v }))}
                  />
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="table">
                <div style={{ minHeight: "500px" }}>
                  <Table
                    filters={filters}
                    setLoading={(v) => setLoading((p) => ({ ...p, table: v }))}
                    loading={loading.table}
                    messageHub={hideFilters}
                  />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </StyledTabContainer>
        </Tab.Container>
      </div>
      {/* </ReactGridLayout> */}
      {tzOffset !== 0 && hideUTCWarning !== "true" && (
        <div className="text-center well well-sm bg-purple-gradient margin-0">
          This report is set in Universal Time Coordinated (UTC). The current
          UTC time is {new Date().toUTCString()}. Please submit your report
          request in UTC time.
          <button
            type="button"
            className="btn btn-colored btn-xs float-end"
            onClick={() => {
              setHideUTCWarning("true");
              localStorage.setItem("hideUTCWarning", "true");
            }}
          >
            X
          </button>
        </div>
      )}
    </>
  );
}

export default Report;
